<template>
  <EButton
    v-click-blur
    :href="href"
    variant="outline"
    :mobile-stack="mobileStack"
    as="a"
    target="_blank"
    icon="source-google-maps"
    icon-size="m"
    :size="isTabletUp ? 'm' : 'l'"
    rel="noreferrer"
    class="directions-button"
    :aria-label="$t('common.maps.directions')"
    v-on="$listeners"
  >
    <span
      v-if="!hiddenLabelMobile || isTabletUp"
      class="directions-button__label"
    >
      {{ $t('common.maps.directions') }}
    </span>
  </EButton>
</template>

<script>
import { getGoogleMapsDirectionUrl } from '~~/common/js/universal/url-utils';
import EButton from '~~/common/vue/components/button';
import screen from '~~/common/vue/mixins/screen';

export default {
  name: 'EDirectionsButton',
  components: {
    EButton,
  },
  mixins: [screen()],
  props: {
    query: {
      type: String,
      required: true,
    },
    hiddenLabelMobile: {
      type: Boolean,
      default: false,
    },
    /**
     * Whether text should be move below icon on mobile
     */
    mobileStack: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    href() {
      return getGoogleMapsDirectionUrl(this.query);
    },
  },
};
</script>
